import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MaterialModule } from '../material/material.module';
import { ManageUserComponent } from '../system-administration/dialogs/manage-user/manage-user.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ManageUserRolesComponent } from '../system-administration/dialogs/manage-user-roles/manage-user-roles.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { userReducer } from './state/user.reducer';
import { UserEffects } from './state/user.effects';
import { ManageClientRolesComponent } from '../system-administration/dialogs/manage-client-roles/manage-client-roles.component';

@NgModule({
  declarations: [ManageUserComponent, ManageUserRolesComponent, ManageClientRolesComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MaterialModule,
    MatCheckboxModule,
    StoreModule.forFeature('user', userReducer),
    EffectsModule.forFeature([UserEffects]),
  ],
})
export class UsersModule {}
